<template>
    <div id="mysidebar" class="w-11/12">
        <div class="flex justify-center card-background">
            <vx-card class="xl:w-full lg:w-8/12 md:w-full shadow-lg custom-height px-4">
                <action-bar class="action-bar">
                    <template v-slot:left>
                        <vx-action-icon
                            :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
                            @click="navBack"
                        >
                        </vx-action-icon>
                        <h2 class="ml-5">{{ details.id ? 'Edit Genre' : 'Create Genre' }}</h2>
                    </template>
                </action-bar>
                <form ref="form" @submit.prevent="saveGenre" class="">
                    <div class="flex justify-evenly mt-5">
                        <div class="w-6/12 px-2">
                            <div class="w-full">
                                <vx-input
                                    label="Genre Name"
                                    name="Genre Name"
                                    :rules="['required']"
                                    v-model="details.name"
                                    class="w-full mt-2"
                                    placeholder="Enter genre name"
                                />

                                <vs-select
                                    placeholder="Search and select coupons"
                                    multiple
                                    autocomplete
                                    class="w-full"
                                    label="Coupon(s)"
                                    v-model="selectedCoupons"
                                >
                                    <vs-select-item
                                        :key="coupon.id"
                                        :value="coupon.id"
                                        :text="coupon.code"
                                        v-for="coupon in coupons"
                                    />
                                </vs-select>

                                <div class="my-4">
                                    <label for="Genre Header Colour" class="vs-input--label">
                                        Genre Header Colour
                                    </label>
                                    <input
                                        label="Genre Header Colour"
                                        name="Genre Header Colour"
                                        type="color"
                                        v-model="details.headerColour"
                                        class="w-full"
                                        placeholder="Enter genre colour"
                                    />
                                </div>
                                <div class="my-4">
                                    <label for="Start Button Colour" class="vs-input--label">
                                        Start Button Colour
                                    </label>
                                    <input
                                        label="Start Button Colour"
                                        name="Start Button Colour"
                                        type="color"
                                        v-model="details.startButtonColour"
                                        class="w-full"
                                        placeholder="Enter Start Button Colour"
                                    />
                                </div>
                                <div class="flex justify-between">
                                    <vx-resource-set
                                        :resources="headerImage"
                                        allow-create
                                        allow-delete
                                        :limit="1"
                                        read-only
                                        justify="center"
                                        text="Upload Header Image"
                                        class="mr-2 imageUploaderText"
                                        @uploaded="setHeaderImage"
                                        label="Header Image"
                                    >
                                    </vx-resource-set>

                                    <vx-resource-set
                                        :resources="backgroundImage"
                                        allow-create
                                        allow-delete
                                        :limit="1"
                                        read-only
                                        justify="center"
                                        text="Upload Background Image"
                                        class="ml-2 imageUploaderText"
                                        @uploaded="setBackgroundImage"
                                        label="Background Image"
                                    >
                                    </vx-resource-set>
                                </div>

                                <div class="flex w-full">
                                    <vx-resource-set
                                        :resources="playerGraphicImage"
                                        allow-create
                                        allow-delete
                                        :limit="1"
                                        read-only
                                        justify="center"
                                        text="Upload Background Image"
                                        class="ml-2 imageUploaderText"
                                        @uploaded="setPlayerGraphicImage"
                                        label="Player Graphic Image"
                                    >
                                    </vx-resource-set>
                                </div>

                                <div class="flex vs-row">
                                    <div
                                        class="w-1/5 my-4 text-center"
                                        v-for="interest in interests"
                                        :key="interest.id"
                                    >
                                        <vx-checkbox
                                            v-model="selectedInterests"
                                            :vs-value="interest.id"
                                        >
                                            {{ interest.name }}
                                        </vx-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex justify-center mt-10 relative">
                        <button type="submit" class="create w-1/6 h-12 z-50">
                            {{ genreID ? 'Save' : 'Create' }}
                        </button>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>

<script>
import ActionBar from '@/components/custom/ActionBar'
import { mapParams } from '@/plugins/mappers'

export default {
    name: 'create-genre',
    components: {
        ActionBar
    },
    computed: {
        ...mapParams({
            url_id: 'genre_id'
        }),
        genreID() {
            return this.url_id
        }
    },
    props: {},
    data() {
        return {
            details: {
                name: null,
                headerColour: '#9DD5CD',
                startButtonColour: '#FFFFFF',
                interests: [],
                coupons: []
            },
            interests: [],
            selectedInterests: [],
            headerImage: [],
            backgroundImage: [],
            playerGraphicImage: [],
            coupons: [],
            selectedCoupons: [],
            columns: [
                { title: 'ID', value: 'id' },
                { title: 'Code', value: 'code' }
            ]
        }
    },
    methods: {
        async saveGenre() {
            this.loading = true
            if (await this.validate()) {
                try {
                    if (this.selectedInterests.length < 1) {
                        this.notifyError('Error', `At least one interest must be chosen`, 5000)
                        return
                    }

                    if (!this.headerImage.any() || !this.headerImage[0].src) {
                        this.notifyError('Error', `A header image must be uploaded`, 5000)
                        return
                    }

                    var response

                    this.details.interests = []

                    this.selectedInterests.forEach((i) => {
                        this.details.interests.push({ id: i })
                    })

                    const updatedCoupons = this.selectedCoupons.map((c) => ({ id: c }))
                    this.details.coupons = updatedCoupons

                    if (this.details.id) {
                        //update
                        response = await this.$api.genre.updateGenre(this.details)
                        await this.saveHeaderImage(response.id)
                        await this.saveBackgroundImage(response.id)
                        await this.savePlayerGraphicImage(response.id)

                        this.notifySuccess(
                            'Updated successfully',
                            'Genre Updated successfully.',
                            5000
                        )
                    } else {
                        //create
                        response = await this.$api.genre.createGenre(this.details)
                        await this.saveHeaderImage(response.id)
                        await this.saveBackgroundImage(response.id)
                        await this.savePlayerGraphicImage(response.id)

                        this.notifySuccess(
                            'Created successfully',
                            'Genre created successfully.',
                            5000
                        )
                        this.$router.replace(`/genres/${response.id}`)
                    }
                } catch (err) {
                    console.error(err)

                    this.notifyError('Error', `Error message: ${err}`, 5000)
                } finally {
                    this.loading = false
                }
            }
        },
        setHeaderImage(newImage) {
            this.$set(this.headerImage, 0, newImage)
        },
        setBackgroundImage(newImage) {
            this.$set(this.backgroundImage, 0, newImage)
        },
        setPlayerGraphicImage(newImage) {
            this.$set(this.playerGraphicImage, 0, newImage)
        },
        async saveHeaderImage(id) {
            if (this.headerImage.any() && this.headerImage[0].file) {
                await this.$api.genre.updateHeaderImage(id, this.headerImage[0])
            }
        },
        async saveBackgroundImage(id) {
            if (this.backgroundImage.any() && this.backgroundImage[0].file) {
                await this.$api.genre.updateBackgroundImage(id, this.backgroundImage[0])
            }
        },
        async savePlayerGraphicImage(id) {
            if (this.playerGraphicImage.any() && this.playerGraphicImage[0].file) {
                await this.$api.genre.updatePlayerGraphicImage(id, this.playerGraphicImage[0])
            }
        },
        navBack() {
            this.$router.go(-1)
        },
        async getDetails() {
            if (this.genreID) {
                this.loading = true
                try {
                    this.details = await this.$api.genre.fetchGenre(this.genreID)
                    this.details.interests.forEach((i) => {
                        this.selectedInterests.push(i.id)
                    })

                    this.details.coupons.forEach((c) => {
                        this.selectedCoupons.push(c.id)
                    })

                    if (this.details.headerImage) {
                        this.setHeaderImage(this.details.headerImage)
                    }
                    if (this.details.backgroundImage) {
                        this.setBackgroundImage(this.details.backgroundImage)
                    }

                    if (this.details.playerGraphicImage) {
                        this.setPlayerGraphicImage(this.details.playerGraphicImage)
                    }
                } catch (err) {
                    console.error(err)
                    this.notifyError(
                        'Communication Error',
                        'Could not retrieve genre details from server, please check your connection and try again.',
                        2000
                    )
                } finally {
                    this.loading = false
                }
            }
        }
    },
    watch: {
        genreID: {
            handler: async function (genre_id) {
                if (genre_id) {
                    await this.getDetails()
                }
            },
            immediate: true
        }
    },
    async mounted() {
        const interestResponse = await this.$api.interest.fetchInterests()
        this.interests = interestResponse.data

        const couponResponse = await this.$api.coupon.fetchCoupons({})
        this.coupons = couponResponse.data
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
.card-background {
    background: transparent;
    height: 100%;
}
.custom-height {
    min-height: 540px;
}
.create {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
    letter-spacing: 2px;
}

.imageUploaderText {
    font-size: 0.85rem;
}
</style>
